import { CATALOG_TYPE_ITEMS_CATEGORY_RECOMMENDATIONS } from '../types/catalogTypes';
import { CATALOG_STATUS_ACTIVE } from '../statuses/catalogStatus';

export const ITEM_CATEGORY_RECOMMENDATIONS = {
  catalogId: CATALOG_TYPE_ITEMS_CATEGORY_RECOMMENDATIONS,
  catalogType: CATALOG_TYPE_ITEMS_CATEGORY_RECOMMENDATIONS,
  catalogStatus: CATALOG_STATUS_ACTIVE,
  catalogName: 'Uncategorised Items (Curated Shops)',
};
